
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useMutation } from '@apollo/client';
import './ws-client.scss';
import { CREATE_WS_CLIENT, GET_WS_CLIENTS } from '../../../graphql/ws-admin-gql';
import { notifySuccess } from '../../../services/notification';
import SpinnerOverlay from '../../common/spinner/spinner';
import { AddIcon, CancelIcon } from '../../common/icons';
import WsClientForm from './ws-client-form';
import { getFormDataObject } from '../../../utils/commons';
import { IWsClientInput } from '../../../types/ws-admin';
import { Toggleable } from '../../../hook/useToggle';
import { encryptRSA } from '../../../utils/encrypt';

const WsClientCreate = (props: Toggleable) => {
    const { isOpen, toggle } = props

    const [createWsClient, { loading: loadingSave }] = useMutation(CREATE_WS_CLIENT)

    const handleSubmit = (event: any) => {
        event.preventDefault()

        const input = getFormDataObject<IWsClientInput>(event.currentTarget)

        createWsClient({
            variables: {
                input: {...input, password: encryptRSA(input.password!)}
            },
            refetchQueries: [{
                query: GET_WS_CLIENTS
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    return (
        <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Create New Client</ModalHeader>
            <ModalBody>
                <WsClientForm id="new_client_form" onSubmit={handleSubmit} autoFocus={true} />
            </ModalBody>
            <ModalFooter>
                <Button form="new_client_form" type="submit" color="primary">
                    <AddIcon /> Create
                </Button >
                <Button color="secondary" onClick={toggle}>
                    <CancelIcon /> Cancel
                </Button>

                {loadingSave && <SpinnerOverlay />}
            </ModalFooter>
        </Modal>
    )
}

export default WsClientCreate
